module.exports = __webpack_public_path__ + "public/img/Komunikasi Efektif dan Negosiasi Bagi Staf Penjualan.8358f2c0.png";